import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    lat: Number,
    lng: Number,
    radius: { type: Number, default: 8047 },
    zoom: { type: Number, default: 11 }
  }

  static targets = ["container"]

  async connect() {
    const L = await import("leaflet")

    this.map = L.map(this.containerTarget, {
      scrollWheelZoom: false,
      dragging: true,
      zoomControl: true
    }).setView([this.latValue, this.lngValue], this.zoomValue)

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      maxZoom: 18
    }).addTo(this.map)

    L.circle([this.latValue, this.lngValue], {
      radius: this.radiusValue,
      color: "oklch(0.65 0.15 240)",
      fillColor: "oklch(0.65 0.15 240)",
      fillOpacity: 0.15,
      weight: 2
    }).addTo(this.map)

    setTimeout(() => this.map.invalidateSize(), 100)
  }

  disconnect() {
    if (this.map) {
      this.map.remove()
      this.map = null
    }
  }
}
